import { getMainColor, isValidationColor } from '@gef-ui/material-theme-utils/colors';
import React from 'react';
import CheckBoxFilled from '../../Icons/CheckBoxFilled';
import CheckBoxOutlineBlankOutlined from '../../Icons/CheckBoxOutlineBlankOutlined';
import IndeterminateCheckBoxFilled from '../../Icons/IndeterminateCheckBoxFilled';
export default function Checkbox(theme) {
    return {
        MuiCheckbox: {
            defaultProps: {
                icon: /*#__PURE__*/ React.createElement(CheckBoxOutlineBlankOutlined, null),
                checkedIcon: /*#__PURE__*/ React.createElement(CheckBoxFilled, null),
                indeterminateIcon: /*#__PURE__*/ React.createElement(IndeterminateCheckBoxFilled, null)
            },
            styleOverrides: {
                root: (input)=>({
                        color: isValidationColor(input) ? getMainColor(input) : undefined,
                        padding: theme.spacing(1),
                        '&.Mui-checked.Mui-disabled, &.Mui-disabled': {
                            color: theme.palette.action.disabled
                        },
                        '& .MuiSvgIcon-fontSizeMedium': {
                            width: 24,
                            height: 24
                        },
                        '& .MuiSvgIcon-fontSizeSmall': {
                            width: 20,
                            height: 20
                        },
                        svg: {
                            fontSize: 24,
                            '&[font-size=small]': {
                                fontSize: 20
                            }
                        }
                    })
            }
        }
    };
}
